/* eslint-disable react/prop-types */
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import {FormControlLabel, Radio} from '@mui/material';

const RadioOption = ({value, label, field}) => {
  // eslint-disable-next-line react/prop-types
  const isChecked = field.value === value;

  return (
    <FormControlLabel
      value={value}
      label={label}
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: 13,
          color: 'primary.main',
          fontWeight: 100,
          ml: 1
        }
      }}
      control={
        <Radio
          checked={isChecked}
          onChange={() => field.onChange(value)}
          sx={{
            backgroundColor: isChecked ? 'primary.main' : 'white',
            width: 18,
            height: 18,
            '&:hover': isChecked ? {backgroundColor: 'primary.main'} : {}
          }}
          icon={
            <CircleOutlinedIcon
              sx={{
                width: 20,
                height: 20
              }}
            />
          }
          checkedIcon={
            <CheckIcon
              sx={{
                width: 16,
                height: 16,
                color: 'white !important'
              }}
            />
          }
        />
      }
    />
  );
};

export default RadioOption;
